
import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gradient-to-br from-[#0A1628] to-[#1a2d4d] text-white pt-16 pb-8">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Sapphire Gayrimenkul</h3>
            <p className="text-sm text-gray-300 mb-4 leading-relaxed">
              Türkiye'nin en güvenilir devremülk alım-satım platformu. Hayalinizdeki tatili gerçeğe dönüştürüyoruz.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Hızlı Bağlantılar</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-300 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/ilanlar" className="text-sm text-gray-300 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  İlanlar
                </Link>
              </li>
              <li>
                <Link to="/tesisler" className="text-sm text-gray-300 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  Tesisler
                </Link>
              </li>
              <li>
                <Link to="/ilan-ver" className="text-sm text-gray-300 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  İlan Ver
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Yasal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/hakkinda" className="text-sm text-gray-300 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-sm text-gray-300 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  İletişim
                </Link>
              </li>
              <li>
                <Link to="/kvkk" className="text-sm text-gray-300 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  KVKK
                </Link>
              </li>
              <li>
                <Link to="/gizlilik" className="text-sm text-gray-300 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  Gizlilik Politikası
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">İletişim</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-[#D4AF37]"></i>
                </div>
                <a href="tel:+905551234567" className="text-sm text-gray-300 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  +90 555 123 45 67
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-[#D4AF37]"></i>
                </div>
                <a href="mailto:info@sapphiregayrimenkul.com" className="text-sm text-gray-300 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  info@sapphiregayrimenkul.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-[#D4AF37]"></i>
                </div>
                <span className="text-sm text-gray-300">
                  İstanbul, Türkiye
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="text-center">
            <img
              src="https://public.readdy.ai/ai/img_res/87d6588e599b8c113db7202c3203efd6.jpg"
              alt="Sapphire Gayrimenkul"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-sm text-gray-400">
              © 2024 Sapphire Gayrimenkul. Tüm hakları saklıdır.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
